// extracted by mini-css-extract-plugin
module.exports = {"Categories":"Categories___dboKq","CategoriesAction":"CategoriesAction___10lr6"};